// Base route
import Login from '@/views/Login.vue';
import LoginChristmas from '@/views/LoginChristmas.vue';
import ForgotPassword from '@/views/ForgotPassword.vue';
import VerifySuccess from '@/views/VerifySuccess.vue';
import Setting from '@/views/Setting.vue';
import Register from '@/views/Register.vue';
import ResetPassword from '@/views/ResetPassword.vue';
import NotFound from '@/views/404.vue';
import Maintenance from '@/views/503.vue';
import Menu from '@/views/Menu.vue';
import Notification from '@/views/Notification.vue';
import ShareLink from '@/views/ShareLink.vue';
import PenerimaanBarangMasuk from '@/views/pusat/gudang/penerimaan/barang-dari-supplier/Tambah.vue'

// Layout
import LayoutMenu from '@/layouts/LayoutMenu.vue';
import LayoutDefault from '@/layouts/LayoutDefault.vue';

export let baseRoutes = [
  {
    path: '/',
    name: 'Home',
    component: Menu,
    meta: {
      layout: LayoutMenu,
      auth: true,
      checkRole: true,
      withoutParent: true
    },
  },
  {
    path: '/s/:code',
    name: 'ShareLink',
    component: ShareLink,
    meta: {
      title: 'Share Link'
    }
  },
  // Auth
  {
    path: '/login',
    name: 'Login',
    component: Login,
    meta: {
      title: 'Halaman Login',
      withoutParent: true,
      guest: true,
    },
  },
  {
    path: '/newlogin',
    name: 'New  Login',
    component: LoginChristmas,
    meta: {
      title: 'Login Page',
      withoutParent: true,
    },
  },
  {
    path: '/notification',
    name: 'notification',
    component: Notification,
    meta: {
      auth: true,
      title: 'Notifikasi',
      withoutParent: true,
      layout: LayoutDefault,
    },
  },
  {
    path: '/settings',
    name: 'Pengaturan',
    component: Setting,
    meta: {
      auth: true,
      title: 'Pengaturan Akun',
      withoutParent: true,
      layout: LayoutDefault,
    },
  },
  {
    path: '/settings/:id',
    name: 'settings.office',
    component: Setting,
    meta: {
      auth: true,
      title: 'Pengaturan Akun',
      withoutParent: true,
      layout: LayoutDefault,
    },
  },
  {
    path: '/register',
    name: 'Register',
    component: Register,
    meta: {
      title: 'Register Page',
      withoutParent: true,
    },
  },
  {
    path: '/lupa-password',
    name: 'ForgotPassword',
    component: ForgotPassword,
    meta: {
      title: 'Lupa Password',
      withoutParent: true,
    },
  },
  {
    path: '/terima/:id',
    component: PenerimaanBarangMasuk,
    meta: {
      title: 'Penerimaan Barang Masuk',
      withoutParent: true,
      name: 'terima-semua'
    },
  },
  {
    path: '*',
    name: 'NotFound',
    component: NotFound,
    meta: {
      title: 'Not Found',
      withoutParent: true,
    },
  },
  {
    path: '/email/verify/success',
    name: 'Verify Success',
    component: VerifySuccess,
    meta: {
      title: 'Verify Success',
      withoutParent: true,
    },
  },
  {
    path: '/reset-password/:token/:email',
    name: 'reset-password',
    component: ResetPassword,
    meta: {
      title: 'Reset Password',
      withoutParent: true,
    },
  },
  {
    path: '/maintenance',
    name: 'maintenance',
    component: Maintenance,
    meta: {
      title: 'Maintenance',
      withoutParent: true,
    },
  },
];
